// mui
import { useTheme } from "@mui/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import TableOfContent from "components/TableOfContent";

export default function BlogSidebarActions({ TOCData, url }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flex: "0 0 30%",
        flexDirection: "column",
        margin: "10% 5% 0 0",
        zIndex: 2,
        position: "sticky",
        top: "6em",
        height: "100%",

        [theme.breakpoints.down("md")]: {
          display: "none",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          marginTop: "10px",
          flexDirection: "column",
          width: "75%",
          [theme.breakpoints.down("md")]: {
            display: "flex",
            flexDirection: "row",
            marginTop: "0px",
            position: "sticky",
            width: "100%",
            background: "white",
            height: "4.5em",
            justifyContent: "space-between",
            margin: 0,
          },
        }}
      >
        <Button
          href={`/loans?ref=${url}_sidebar_actions_button`}
          sx={{
            width: "100%",
            fontWeight: 600,
            margin: theme.spacing(1),
            textDecoration: "none !important",
            color: "white !important",
            "&:hover, :focus": {
              color: `${theme.palette.primary.contrastColor} !important`,
              backgroundColor: `${theme.palette.success.dark} !important`,
            },
            [theme.breakpoints.down("md")]: {
              width: "auto",
            },
          }}
          variant="contained"
        >
          Loans
        </Button>
        <Typography
          component="h2"
          sx={{
            width: "100%",
            display: "block",
            textAlign: "right",
            padding: theme.spacing(0),
            margin: theme.spacing(0, "auto", 0, "auto"),
            fontSize: theme.spacing(1.5),
            [theme.breakpoints.down("md")]: {
              margin: theme.spacing(2, "auto", 0, "auto"),
              fontSize: theme.spacing(2),
            },
          }}
        >
          *Quote takes 1 minute, no credit pull
        </Typography>
        <Button
          href={`/insurance?ref=${url}_sidebar_actions_button`}
          sx={{
            width: "100%",
            fontWeight: 600,
            margin: theme.spacing(1),
            textDecoration: "none !important",
            color: "white !important",
            "&:hover, :focus": {
              color: `${theme.palette.primary.contrastColor} !important`,
              backgroundColor: `${theme.palette.success.dark} !important`,
            },
            [theme.breakpoints.down("md")]: {
              width: "auto",
            },
          }}
          variant="contained"
        >
          Insurance
        </Button>
        <Typography
          component="h2"
          sx={{
            width: "100%",
            display: "block",
            textAlign: "right",
            padding: theme.spacing(0),
            margin: theme.spacing(0, "auto", 0, "auto"),
            fontSize: theme.spacing(1.5),
            [theme.breakpoints.down("md")]: {
              margin: theme.spacing(2, "auto", 0, "auto"),
              fontSize: theme.spacing(2),
            },
          }}
        >
          *1 quote from 40+ carriers
        </Typography>
        <Button
          href={`/listings?ref=${url}_sidebar_actions_button`}
          sx={{
            textAlign: "left",
            width: "100%",
            fontWeight: 600,
            margin: theme.spacing(1),
            textDecoration: "none !important",
            color: "white !important",
            "&:hover, :focus": {
              color: `${theme.palette.primary.contrastColor} !important`,
              backgroundColor: `${theme.palette.success.dark} !important`,
            },
            [theme.breakpoints.down("md")]: {
              width: "auto",
            },
          }}
          variant="contained"
        >
          Listings
        </Button>
        <Typography
          component="h2"
          sx={{
            width: "100%",
            display: "block",
            textAlign: "right",
            padding: theme.spacing(0),
            margin: theme.spacing(0, "auto", 0, "auto"),
            fontSize: theme.spacing(1.5),
            [theme.breakpoints.down("md")]: {
              margin: theme.spacing(2, "auto", 0, "auto"),
              fontSize: theme.spacing(2),
            },
          }}
        >
          *New listings daily
        </Typography>
      </Box>
      {TOCData.length > 0 && <TableOfContent TOCData={TOCData} />}
    </Box>
  );
}
